// extracted by mini-css-extract-plugin
module.exports = {"alertContainer":"Popup_alertContainer__2coYU","alertText":"Popup_alertText__20oLs","buttonContainer":"Popup_buttonContainer__2oLGT"};